import { sum } from '@10000/common'
import { Body, Box } from '.'
import './BarGraph.scss'

export const BarGraph = ({ values, selectedValue, onClick }) => {
  const total = sum(values)
  const max = Math.max(...values)

  return (
    <Box
      width="100%"
      height="100%"
      gap={16}
      justifyContent="center"
      className="bar-graph"
    >
      {values.map((value, i) =>
        <Box
          key={i}
          grow
          gap={8}
          column
          fullHeight
          justifyContent="flex-end"
          alignItems="center"
          onClick={() => onClick?.(i)}
          cursor="pointer"
          className="column"
        >
          <Body alt bold>
            {Math.round(value / total * 100) || 0}%
          </Body>

          <Box
            container
            fullWidth
            height={`${(value / max * 100) || 1}%`}
            background={selectedValue === i ? 'var(--yellow)' : 'var(--blue)'}
            overflow="hidden"
            className="bar"
          >
            <Box fullWidth fullHeight className="overlay" />
          </Box>

          <Body alt bold size={24}>
            {String.fromCharCode(65 + i)}
          </Body>
        </Box>
      )}
      <Box height={318} />
    </Box>
  )
}